export function firebaseConfig() {
  const key = atob("QUl6YVN5QVV6T2JMblZESURYYTB4ZUxmSVpLV3BiLTJZSWpYSXBJ");
  return {
    apiKey: key,
    authDomain: "collaborative-learning-ec215.firebaseapp.com",
    databaseURL: "https://collaborative-learning-ec215.firebaseio.com",
    projectId: "collaborative-learning-ec215",
    storageBucket: "collaborative-learning-ec215.appspot.com",
    messagingSenderId: "112537088884",
    appId: "1:112537088884:web:c51b1b8432fff36faff221",
    measurementId: "G-XP472LRY18"
  };
}
